<template>
  <div id="panzoom-wrapper" class="wrapper">
    <slot></slot>
  </div>
</template>

<script>
import panzoom from 'panzoom'

export default {
  name: 'panzoom-wrapper',
  data () {
    return {
      instance: null
    }
  },
  props: {
    initialZoom: {
      type: Number,
      default: 1
    }
  },
  methods: {
    initPanzoom () {
      if (this.instance) this.instance.dispose()

      this.instance = panzoom(document.getElementById('panzoom-wrapper'), {
        maxZoom: 2,
        minZoom: 0.3,
        smoothScroll: false,
        bounds: true,
        zoomSpeed: 0.065,
        boundsPadding: -1,
        initialZoom: this.initialZoom,
        filterKey: () => true
      })
        .zoomAbs(0, 0, this.initialZoom)
    }
  },
  created () {
    this.$parent.$on('panzoom-reset', this.initPanzoom)
  },
  mounted () {
    this.initPanzoom()
  }
}
</script>

<style lang="scss" scoped>
  .wrapper {
    outline: none;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    >* {
      outline: none;
    }
  }
</style>
